/* eslint-disable no-extra-parens */
import {
    BellIcon,
    ChatAltIcon,
    FingerPrintIcon,
    HeroEllipsisVerticalIcon,
    HeroGlobeEuropeIcon,
    HeroHomeIcon,
    HeroWindowIcon,
    KeyIcon,
    UserIcon,
} from 'components/Icon'

import {
    Dropdown, DropdownButtonNew, DropdownContent,
} from 'components/Dropdown'

import {
    dropdownsButtonsWrapper,
    list,
} from '../styles'

import Button from 'components/Button'
import {Icon} from 'components/Icon/types'

import React from 'react'
import Tooltip from 'components/Tooltip'

import {navigation} from 'navigation'
import {styled} from 'stitches/config'
import {useTranslation} from 'react-i18next'

const StyledList = styled('ul', list)
const StyledDropdownButtonsWrapper = styled('div', dropdownsButtonsWrapper)

export const SideMenuSettingsView = () => {
    const {t} = useTranslation()

    return (
        <StyledList>
            <li>
                <Dropdown>
                    <DropdownButtonNew caret={false} color='text' iconRight={HeroEllipsisVerticalIcon as unknown as Icon} />
                    <DropdownContent direction='left' >
                        <StyledDropdownButtonsWrapper>
                            <Button color='text' iconLeft={UserIcon} onPress={(): void => { navigation.push('Settings', {tab: 'profile'}) }} text={t('User profile')} />
                            <Button color='text' iconLeft={KeyIcon} onPress={(): void => { navigation.push('Settings', {tab: 'account'}) }} text={t('Account & password')} />
                            <Button color='text' iconLeft={BellIcon} onPress={(): void => { navigation.push('Settings', {tab: 'notifications'}) }} text={t('Notifications')} />
                            <Button
                                color='text'
                                iconLeft={HeroWindowIcon as unknown as Icon}
                                onPress={(): void => { navigation.push('Settings', {tab: 'user-interface'}) }}
                                text={t('User interface')}
                            />
                            <Button
                                color='text'
                                iconLeft={HeroGlobeEuropeIcon as unknown as Icon}
                                onPress={(): void => { navigation.push('Settings', {tab: 'language'}) }}
                                text={t('Language and region')}
                            />
                            <Button color='text' iconLeft={ChatAltIcon} onPress={(): void => { navigation.push('Settings', {tab: 'canned-messages'}) }} text={t('Canned messages')} />
                            <Button color='text' iconLeft={HeroHomeIcon as unknown as Icon} onPress={(): void => { navigation.push('Home') }} text={t('Home')} />
                            <Button color='text' iconLeft={FingerPrintIcon} onPress={(): void => { navigation.push('Settings', {tab: 'master-keys'}) }} text={t('Master keys')} />
                        </StyledDropdownButtonsWrapper>
                    </DropdownContent>
                </Dropdown>
            </li>
            <li>
                <Button color='text' data-tooltip-id='user-profile' iconLeft={UserIcon} onPress={(): void => { navigation.push('Settings', {tab: 'profile'}) }} text='' />
                <Tooltip id='user-profile' position='right' singleLine>
                    {t('User profile')}
                </Tooltip>
            </li>
            <li>
                <Button color='text' data-tooltip-id='account' iconLeft={KeyIcon} onPress={(): void => { navigation.push('Settings', {tab: 'account'}) }} text='' />
                <Tooltip id='account' position='right' singleLine>
                    {t('Account & password')}
                </Tooltip>
            </li>
            <li>
                <Button color='text' data-tooltip-id='notifications' iconLeft={BellIcon} onPress={(): void => { navigation.push('Settings', {tab: 'notifications'}) }} text='' />
                <Tooltip id='notifications' position='right' singleLine>
                    {t('Notifications')}
                </Tooltip>
            </li>
            <li>
                <Button
                    color='text'
                    data-tooltip-id='user-interface'
                    iconLeft={HeroWindowIcon as unknown as Icon}
                    onPress={(): void => { navigation.push('Settings', {tab: 'user-interface'}) }}
                    text=''
                />
                <Tooltip id='user-interface' position='right' singleLine>
                    {t('User interface')}
                </Tooltip>
            </li>
            <li>
                <Button color='text' data-tooltip-id='language' iconLeft={HeroGlobeEuropeIcon as unknown as Icon} onPress={(): void => { navigation.push('Settings', {tab: 'language'}) }} text='' />
                <Tooltip id='language' position='right' singleLine>
                    {t('Language and region')}
                </Tooltip>
            </li>
            <li>
                <Button color='text' data-tooltip-id='canned' iconLeft={ChatAltIcon} onPress={(): void => { navigation.push('Settings', {tab: 'canned-messages'}) }} text='' />
                <Tooltip id='canned' position='right' singleLine>
                    {t('Canned messages')}
                </Tooltip>
            </li>
            <li>
                <Button color='text' data-tooltip-id='master-keys' iconLeft={FingerPrintIcon} onPress={(): void => { navigation.push('Settings', {tab: 'master-keys'}) }} text='' />
                <Tooltip id='master-keys' position='right' singleLine>
                    {t('Master keys')}
                </Tooltip>
            </li>
        </StyledList>
    )
}
